import React from 'react';
import { getPartner } from '../../../../../../lib/access.es6';

/**
 * Shared premium comparison box component for displaying premium changes
 * Used in ChangeCoverage amendment (Upgrade/Downgrade scenarios)
 *
 * @param {number} oldPremium - Original premium amount in cents
 * @param {number} newPremium - New premium amount in cents
 * @param {string} oldLabel - Label for the old premium (e.g., "Member Only")
 * @param {string} newLabel - Label for the new premium (e.g., "Member & Family")
 * @param {string} changeLabel - Optional custom label for the change amount
 * @param {string} noteText - Optional note text to display below the comparison
 */
const PremiumComparisonBox = ({
  oldPremium,
  newPremium,
  oldLabel = 'Current Premium',
  newLabel = 'New Premium',
  changeLabel = null,
  noteText = null
}) => {
  const currencyCode = getPartner().country.currency_code;
  const premiumChange = newPremium - oldPremium;
  const isIncrease = premiumChange > 0;

  // Determine change label text
  const changeLabelText = changeLabel || (isIncrease ? 'Premium Increase' : 'Premium Decrease');

  return (
    <div style={{
      backgroundColor: '#f5f5f5',
      border: '1px solid #ddd',
      borderRadius: '6px',
      padding: '16px 20px',
      marginBottom: '20px'
    }}>
      <h6 style={{
        fontSize: '14px',
        fontWeight: '600',
        marginBottom: '12px',
        color: '#032A37',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        Premium Change
      </h6>

      <div style={{ marginBottom: '12px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr style={{ borderBottom: '1px solid #ddd' }}>
              <td style={{ padding: '8px 0', fontSize: '14px', color: '#666' }}>
                {oldLabel}:
              </td>
              <td style={{ padding: '8px 0', fontSize: '16px', fontWeight: 'bold', color: '#032A37', textAlign: 'right' }}>
                {currencyCode} {(oldPremium / 100).toFixed(2)}
              </td>
            </tr>
            <tr style={{ borderBottom: '1px solid #ddd' }}>
              <td style={{ padding: '8px 0', fontSize: '14px', color: '#666' }}>
                {newLabel}:
              </td>
              <td style={{ padding: '8px 0', fontSize: '16px', fontWeight: 'bold', color: '#032A37', textAlign: 'right' }}>
                {currencyCode} {(newPremium / 100).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td style={{ padding: '8px 0', fontSize: '14px', color: '#666', fontWeight: '600' }}>
                {changeLabelText}:
              </td>
              <td style={{
                padding: '8px 0',
                fontSize: '18px',
                fontWeight: 'bold',
                color: isIncrease ? '#dc3545' : '#28a745',
                textAlign: 'right'
              }}>
                {isIncrease ? '+' : ''}{currencyCode} {(Math.abs(premiumChange) / 100).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {noteText && (
        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: '4px',
          padding: '10px 12px',
          marginTop: '12px'
        }}>
          <p style={{ margin: 0, fontSize: '13px', color: '#856404' }}>
            {noteText}
          </p>
        </div>
      )}
    </div>
  );
};

export default PremiumComparisonBox;
